/* =========================================================================
   INNESKATT – global.js
   Lättviktig vanilla JS. Inga externa bibliotek.
   - Scroll-animationer (IntersectionObserver)
   - FAQ-accordion
   - Mobilmeny
   - Mjuk scroll för CTA-länkar
   - Variantväljare (uppdaterar pris + köpknapp)
   ========================================================================= */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* Scroll-in animationer */
  function initScrollAnimations() {
    var els = document.querySelectorAll('[data-animate]');
    if (!els.length) { return; }
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-animate-delay');
          if (delay) { entry.target.style.transitionDelay = delay + 'ms'; }
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* FAQ / accordion */
  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion-item]');
        if (!item) { return; }
        var panel = item.querySelector('[data-accordion-panel]');
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (panel) { panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : null; }
      });
    });
  }

  /* Mobilmeny */
  function initMenuToggle() {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('aria-controls');
        var target = id && document.getElementById(id);
        if (!target) { return; }
        var isOpen = target.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.body.classList.toggle('menu-open', isOpen);
      });
    });
  }

  /* Mjuk scroll för länkar med data-scroll-to="#id" */
  function initSmoothScroll() {
    document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var sel = link.getAttribute('data-scroll-to');
        var target = sel && document.querySelector(sel);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          document.body.classList.remove('menu-open');
        }
      });
    });
  }

  /* Variantväljare – uppdaterar pris + köpknappens status */
  function initVariantSelectors() {
    document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var priceSel = sel.getAttribute('data-price-target');
        var priceEl = priceSel && document.querySelector(priceSel);
        if (priceEl && opt.dataset.price) { priceEl.textContent = opt.dataset.price; }
        var form = sel.closest('form');
        var btn = form && form.querySelector('button[name="add"]');
        if (btn) {
          if (opt.dataset.available === 'false') {
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('is-soldout');
          } else {
            btn.removeAttribute('disabled');
            btn.classList.remove('is-soldout');
          }
        }
      });
    });
  }

  ready(function () {
    initScrollAnimations();
    initAccordions();
    initMenuToggle();
    initSmoothScroll();
    initVariantSelectors();
  });
})();
